// import { BANK_CODES } from './bankCodes';
import { COUNTRY_CODES } from './countryCodes';
import { STATES } from './states';

const IncomeBracket = [
  { value: '31', label: 'Less than 1 Lakh' },
  { value: '32', label: '1-5 Lakhs' },
  { value: '33', label: '5-10 Lakhs' },
  { value: '34', label: '10-25 Lakhs' },
  { value: '35', label: '25 Lakhs- 1 Crore' },
  { value: '36', label: 'More than 1 Crore' },
];

export const NOMINEE_RELATIONS = [
  { value: 'SON', label: 'Son' },
  { value: 'DAUGHTER', label: 'Daughter' },
  { value: 'HUSBAND', label: 'Husband' },
  { value: 'WIFE', label: 'Wife' },
  { value: 'MOTHER', label: 'Mother' },
  { value: 'FATHER', label: 'Father' },
  { value: 'OTHER', label: 'Other' },
];

export const DETAIL_FIELDS = {
  first: [
    {
      name: 'fullName',
      labelName: 'Full Name',
      placeholder: 'e.g. Ankit Gupta (as per PAN card)',
      type: 'text',
      isInvalid: false,
      validationMessage: 'This is required',
      required: false,
      entityKey: 'userPersonalDetails',
      className: 'large-12',
      value: '',
      maxLength: 70,
    },
    {
      name: 'pan',
      labelName: 'PAN Number',
      type: 'text',
      isInvalid: false,
      validationMessage: 'Enter valid PAN number',
      required: false,
      entityKey: 'userPersonalDetails',
      className: '',
      as: 'pan',
      value: '',
      maxLength: 10,
    },
    {
      name: 'phone',
      labelName: 'Mobile Number',
      type: 'text',
      placeholder: '10 digit number',
      isInvalid: false,
      validationMessage: 'This is required',
      required: true,
      entityKey: 'userPersonalDetails',
      value: '',
      maxLength: 10,
    },
    {
      name: 'dateOfBirth',
      labelName: 'Date of Birth',
      type: 'text',
      placeholder: 'DD/MM/YYYY',
      isInvalid: false,
      validationMessage: 'Enter date in DD/MM/YYYY format',
      required: false,
      entityKey: 'userPersonalDetails',
      as: 'date',
      value: '',
    },
    {
      name: 'pincode',
      labelName: 'Pincode',
      placeholder: '6 digit pincode',
      type: 'text',
      isInvalid: false,
      validationMessage: 'This is required',
      required: false,
      entityKey: 'userPersonalDetails',
      value: '',
      maxLength: 6,
    },
    {
      name: 'city',
      labelName: 'City',
      type: 'text',
      isInvalid: false,
      validationMessage: 'This is required',
      required: false,
      entityKey: 'userPersonalDetails',
      value: '',
    },
    {
      name: 'gender',
      labelName: 'Gender',
      type: 'radio',
      isInvalid: false,
      validationMessage: 'This is required',
      required: false,
      entityKey: 'userPersonalDetails',
      value: 'male',
      options: [
        {
          label: 'Male',
          value: 'Male',
        },
        {
          label: 'Female',
          value: 'Female',
        },
      ],
    },
    {
      name: 'maritalStatus',
      labelName: 'Marital Status',
      type: 'radio',
      isInvalid: false,
      validationMessage: 'This is required',
      required: false,
      entityKey: 'userPersonalDetails',
      value: 'UNMARRIED',
      options: [
        {
          label: 'Married',
          value: 'MARRIED',
        },
        {
          label: 'Single',
          value: 'UNMARRIED',
        },
      ],
    },
  ],
  second: [
    {
      name: 'isTaxPayerOutsideIndia',
      labelName: 'I’m an Non Resident Indian (NRI)',
      placeholder: '',
      type: 'toggle-switch',
      entityKey: 'userFatcaDetails',
      value: 'no',
      labelStyles: 'f-optional',
    },
    {
      name: 'accountNo',
      labelName: 'Bank Account Number',
      type: 'text',
      isInvalid: false,
      validationMessage: 'This is required',
      required: false,
      entityKey: 'userBankDetails',
      as: 'number',
      value: '',
      className: 'large-12',
    },
    {
      name: 'nameOfBank',
      labelName: 'Bank Name',
      type: 'text',
      isInvalid: false,
      validationMessage: 'This is required',
      required: false,
      // options: BANK_CODES,
      entityKey: 'userBankDetails',
      value: '',
    },
    {
      name: 'ifscCode',
      labelName: 'IFSC Code',
      type: 'text',
      isInvalid: false,
      validationMessage: 'This is required',
      required: false,
      entityKey: 'userBankDetails',
      value: '',
    },
    {
      name: 'cityOfBank',
      labelName: 'Branch City',
      type: 'text',
      isInvalid: false,
      validationMessage: 'This is required',
      required: false,
      entityKey: 'userBankDetails',
      value: '',
    },
    {
      name: 'annualIncomeCategory',
      labelName: 'Income Range',
      type: 'select',
      isInvalid: false,
      entityKey: 'userFatcaDetails',
      validationMessage: 'This is required',
      required: true,
      value: '33',
      options: IncomeBracket,
    },
    // {
    //   name: 'nomineeName',
    //   labelName: 'Nominee Name',
    //   type: 'text',
    //   isInvalid: false,
    //   validationMessage: 'This is required',
    //   required: false,
    //   entityKey: 'userPersonalDetails',
    //   value: '',
    // },
    // {
    //   name: 'nomineeRelation',
    //   labelName: 'Nominee Relationship',
    //   type: 'select',
    //   isInvalid: false,
    //   validationMessage: 'This is required',
    //   required: false,
    //   entityKey: 'userPersonalDetails',
    //   value: '',
    //   options: NOMINEE_RELATIONS,
    // },
    // {
    //   name: 'nomineeDateOfBirth',
    //   labelName: 'Nominee Date of Birth',
    //   type: 'text',
    //   placeholder: 'DD/MM/YYYY',
    //   isInvalid: false,
    //   validationMessage: 'Enter date in DD/MM/YYYY format',
    //   required: false,
    //   entityKey: 'userPersonalDetails',
    //   as: 'date',
    //   value: '',
    // },
  ],
  third: [
    {
      name: 'nomineeName',
      labelName: 'Nominee Name',
      type: 'text',
      isInvalid: false,
      validationMessage: 'This is required',
      required: false,
      entityKey: 'userPersonalDetails',
      value: '',
    },
    {
      name: 'nomineeRelation',
      labelName: 'Nominee Relationship',
      type: 'select',
      isInvalid: false,
      validationMessage: 'This is required',
      required: false,
      entityKey: 'userPersonalDetails',
      value: '',
      options: NOMINEE_RELATIONS,
    },
    {
      name: 'nomineeDateOfBirth',
      labelName: 'Nominee Date of Birth',
      type: 'text',
      placeholder: 'DD/MM/YYYY',
      isInvalid: false,
      validationMessage: 'Enter date in DD/MM/YYYY format',
      required: false,
      entityKey: 'userPersonalDetails',
      as: 'date',
      value: '',
    },
  ],
  payment: [
    {
      name: 'paymentMode',
      labelName: 'Select your payment option',
      type: 'radio',
      isInvalid: false,
      validationMessage: 'This is required',
      required: false,
      value: '',
      options: [
        {
          label: 'Net Banking',
          value: 'NET_BANKING',
          icon: 'clearsave-frontend/images/netbanking-icon-payment.png',
        },
        {
          label: 'Debit Card',
          value: 'DEBIT_CARD',
          icon: 'clearsave-frontend/images/debit-card-icon-payment.png',
        },
        {
          label: 'RuPay Card',
          value: 'RUPAY_CARD',
          icon: 'clearsave-frontend/images/rupay-card-icon-payment.png',
        },
        {
          label: 'UPI Payment',
          value: 'UPI',
          icon: 'clearsave-frontend/images/upi-icon-payment.png',
        },
      ],
    },
  ],
};

export const NRI_FIELDS = [
  {
    name: 'accountType',
    labelName: 'Account Type',
    type: 'select',
    isInvalid: false,
    validationMessage: 'This is required',
    required: false,
    options: [
      {
        value: 'NRE',
        label: 'NRE',
      },
      {
        value: 'NRO',
        label: 'NRO',
      },
    ],
    entityKey: 'userBankDetails',
    value: '',
  },
  {
    name: 'taxResidenceCountry',
    labelName: 'Country of Tax Residency',
    type: 'select',
    isInvalid: false,
    validationMessage: 'This is required',
    required: false,
    options: COUNTRY_CODES,
    entityKey: 'userFatcaDetails',
    value: '',
  },
  {
    name: 'taxPayerId',
    labelName: 'Tax Identification Number',
    type: 'text',
    isInvalid: false,
    validationMessage: 'This is required',
    required: false,
    entityKey: 'userFatcaDetails',
    value: '',
  },
];

const OCCUPATIONS = [
  { value: '02', label: 'Service' },
  { value: '41', label: 'Private Sector' },
  { value: '42', label: 'Public Sector' },
  { value: '44', label: 'Government Sector' },
  { value: '03', label: 'Professional' },
  { value: '99', label: 'X-Not Categorised' },
  { value: '08', label: 'Self Employed' },
  { value: '05', label: 'Retired' },
  { value: '06', label: 'Housewife' },
  { value: '07', label: 'Student' },
];

const sourceOfWealth = [
  { value: '01', label: 'Salary Income' },
  { value: '02', label: 'Business Income ' },
  { value: '03', label: 'Gift' },
  { value: '04', label: 'Ancestral Property' },
  { value: '05', label: 'Rental Income' },
  { value: '06', label: 'Prize Money' },
  { value: '07', label: 'Royalty' },
  { value: '08', label: 'Others' },
];

export const KYC_FIELDS = [
  // {
  //   name: 'nationality',
  //   labelName: 'Nationality',
  //   type: 'select',
  //   isInvalid: false,
  //   validationMessage: 'This is required',
  //   required: true,
  //   value: 'IN',
  //   options: [
  //     {
  //       label: 'Net Banking',
  //       value: 'NET_BANKING',
  //     },
  //     {
  //       label: 'Debit Card',
  //       value: 'DEBIT_CARD',
  //     },
  //   ],
  // },
  {
    name: 'occupationCode',
    labelName: 'Occupation',
    type: 'select',
    isInvalid: false,
    entityKey: 'userPersonalDetails',
    validationMessage: 'This is required',
    required: false,
    value: '41',
    options: OCCUPATIONS,
  },
  {
    name: 'placeOfBirth',
    labelName: 'Place of Birth',
    type: 'text',
    isInvalid: false,
    entityKey: 'userFatcaDetails',
    validationMessage: 'This is required',
    required: true,
    value: 'INDIA',
  },
  {
    name: 'city',
    labelName: 'City (As per your Address Proof)',
    type: 'text',
    isInvalid: false,
    validationMessage: 'This is required',
    required: true,
    entityKey: 'userPersonalDetails',
    value: '',
  },
  {
    name: 'pincode',
    labelName: 'Pincode (As per your Address Proof)',
    placeholder: '6 digit pincode',
    type: 'text',
    isInvalid: false,
    validationMessage: 'This is required',
    required: false,
    entityKey: 'userPersonalDetails',
    value: '',
  },
  {
    name: 'address',
    labelName: 'Address (As per the Address Proof)',
    type: 'textarea',
    isInvalid: false,
    validationMessage: 'This is required',
    required: false,
    entityKey: 'userPersonalDetails',
    placeholder: 'Max characters 150',
    value: '',
  },
  // {
  //   name: 'country',
  //   labelName: 'Country of Birth',
  //   type: 'select',
  //   isInvalid: false,
  //   validationMessage: 'This is required',
  //   required: true,
  //   value: 'DEBIT_CARD',
  //   options: [
  //     {
  //       label: 'Net Banking',
  //       value: 'NET_BANKING',
  //     },
  //     {
  //       label: 'Debit Card',
  //       value: 'DEBIT_CARD',
  //     },
  //   ],
  // },
  {
    name: 'annualIncomeCategory',
    labelName: 'Annual Income',
    type: 'select',
    isInvalid: false,
    entityKey: 'userFatcaDetails',
    validationMessage: 'This is required',
    required: true,
    value: '33',
    options: IncomeBracket,
  },
  {
    name: 'sourceOfWealth',
    labelName: 'Source of Wealth',
    type: 'select',
    isInvalid: false,
    entityKey: 'userFatcaDetails',
    validationMessage: 'This is required',
    required: true,
    value: '01',
    options: sourceOfWealth,
  },
  {
    name: 'fathersOrSpouseFirstName',
    labelName: 'Fathers Name (As per your PAN card)',
    type: 'text',
    isInvalid: false,
    entityKey: 'userPersonalDetails',
    validationMessage: 'This is required',
    required: true,
    value: '',
  },
  {
    name: 'mothersFirstName',
    labelName: 'Mothers Name',
    type: 'text',
    isInvalid: false,
    entityKey: 'userPersonalDetails',
    validationMessage: 'This is required',
    required: true,
    value: '',
  },
  {
    name: 'isTaxPayerOutsideIndia',
    labelName: 'Do you pay taxes outside India',
    type: 'radio',
    isInvalid: false,
    entityKey: 'userFatcaDetails',
    validationMessage: 'This is required',
    required: false,
    value: 'no',
    options: [
      {
        label: 'No',
        value: 'no',
      },
      {
        label: 'Yes',
        value: 'yes',
      },
    ],
  },
  {
    name: 'pepStatus',
    labelName: 'Are you Politically exposed person',
    type: 'radio',
    isInvalid: false,
    entityKey: 'userFatcaDetails',
    validationMessage: 'This is required',
    required: false,
    value: 'N',
    options: [
      {
        label: 'No',
        value: 'N',
      },
      {
        label: 'Yes',
        value: 'Y',
      },
    ],
  },
];

export const HIDDEN_FIELDS = [
  {
    name: 'branchName',
    labelName: 'Branch Name',
    type: 'text',
    isInvalid: false,
    validationMessage: 'This is required',
    required: true,
    entityKey: 'userBankDetails',
    value: '',
  },
  {
    name: 'state',
    labelName: 'State',
    type: 'select',
    isInvalid: false,
    validationMessage: 'This is required',
    required: false,
    options: STATES,
    entityKey: 'userPersonalDetails',
    value: '',
  },
];

export const ALL_FIELDS = [].concat(
  DETAIL_FIELDS['first'],
  DETAIL_FIELDS['second'],
  DETAIL_FIELDS['third'],
  HIDDEN_FIELDS
);

export const DOWNLOAD_OPTIONS_FIELD = {
  name: 'downloadInvProof',
  labelName:
    'Your tax-saving investment statement(s) for the following years are available',
  type: 'select',
  isInvalid: false,
  required: false,
  value: 'FY1617',
  options: [],
};



// WEBPACK FOOTER //
// ./constants/userFields.ts